export default {
  'menu.system': '系统管理',
  'pages.system.action.column': '操作',
  'pages.system.action.detail': '详情',
  'pages.system.action.edit': '编辑',
  'pages.system.action.refresh': '刷新',
  'pages.system.action.reset': '重置',
  'pages.system.config.create': '新增配置',
  'pages.system.config.description': '描述',
  'pages.system.config.detail': '配置详情',
  'pages.system.config.edit': '编辑配置',
  'pages.system.config.key': '配置键',
  'pages.system.config.value': '配置值',
  'pages.system.empty.data': '暂无数据',
  'pages.system.empty.result': '暂无操作结果',
  'pages.system.health.basic': '基础健康检查',
  'pages.system.health.httpStatus': 'HTTP 状态',
  'pages.system.health.message': '消息',
  'pages.system.health.responseTime': '响应耗时',
  'pages.system.health.service': '服务',
  'pages.system.health.status': '状态',
  'pages.system.health.url': 'URL',
  'pages.system.health.version': '版本',
  'pages.system.message.saved': '操作成功',
  'pages.system.result.key': '键',
  'pages.system.result.value': '值',
  'pages.system.tab.config': '系统配置',
  'pages.system.tab.health': '健康检查',
  'pages.system.tab.tasks': '系统任务',
  'pages.system.task.job': '任务名',
  'pages.system.task.mode': '执行模式',
  'pages.system.task.title': '触发系统任务',
  'pages.system.task.trigger': '触发任务',
  'pages.system.title': '系统管理',
};
